import { Button, Dialog, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import useDelete from '../../hooks/product/useDelete';
import Spinner from '../../components/spinner';
import toast from 'react-hot-toast';

function DeleteBlogs({ open, onClose, blog_id, onDelete, url, queryKey }) {
    const { handleDelete } = useDelete({
        url: url,
        refreshUrl: queryKey,
        successToastMessage: "Blog Deleted Successfully",
        errorToastMessage: "Failed to delete blog",
        onSuccess: () => {
            onClose();
            onDelete();
        },
        onError: (err) => {
            console.error(err);
        }
    });

    const handleDeleteBlog = (e) => {
        e.preventDefault();
        handleDelete({ blog_id });
    };

    return (
        <>
            <Dialog fullWidth={true} maxWidth={'sm'} open={open} onClose={onClose}>
                <div className='bg-white w-full px-5'>
                    <div className='modal-head flex items-center justify-end pt-2'>
                        <div onClick={onClose}>
                            <IconButton>
                                <CloseIcon />
                            </IconButton>
                        </div>
                    </div>
                    <form className='space-y-4' onSubmit={handleDeleteBlog}>
                        <div className='space-y-7'>
                            <div>
                                <h1 className='text-2xl text-red-700 font-semibold text-center'>
                                    Are You Sure You Want To Delete?
                                </h1>
                            </div>
                        </div>
                        <div className='space-x-4 text-center pb-5'>
                            <Button 
                                type='submit' 
                                variant="contained" 
                                color="error"
                            >
                                Delete
                            </Button>

                            <Button 
                                variant="outlined" 
                                color='info' 
                                onClick={onClose}
                            >
                                Close
                            </Button>
                        </div>
                    </form>
                </div>
            </Dialog>
        </>
    );
}

export default DeleteBlogs;